/**
 * @file: parseUrl
 * @Date: 2020-05-06 13:19:01
 */
/**
 * 格式化url -> Object
 * @param {string} url
 */
export default function parseUrl(url = window.location.href) {
    const reg = /([^?=&]+)=([^?=&]+)/g;
    const arr = url.match(reg) || [];
    const resObj = {};
    arr.forEach(item => {
        const res = item.split('=');
        resObj[res[0]] = ['undefined', 'null'].includes(res[1]) ? '' : decodeURIComponent(res[1]);
    });
    return resObj;
}

/**
 * 格式化obj -> url
 * @param {object} param
 */
export function parseQuery(param = {}) {
    if (Object.keys(param).length === 0) {
        return '';
    }

    let tmpArr = [];

    // eslint-disable-next-line guard-for-in
    for (let key in param) {
        tmpArr.push(`${key}=${param[key]}`);
    }

    return tmpArr.join('&');
}
